export default __webpack_public_path__ + "static/media/nft-exchange-icon.22e4dda1.svg";